export default __webpack_public_path__ + "static/media/06.a3402e10.png";